/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { addSeminarCategory, editSeminarCategory } from '../../apis/admin/seminar';
import useForm from '../../hooks/useForm';
import systemAlert from '../../utils/systemAlert';
import { toast } from '../../utils/toast';
import Form from '../Form';
import Modal, { ModalHeader } from '../Modal';

const defaultForm = {
  name: "",
  order: "0",
};

const Category = (props) => {
  const { selectedItem, setSelectedItem, open, setOpen, submit } = props;
  const [fields, setFields] = useState([]);
  const [mode, setMode] = useState('create');

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  useEffect(() => {
    setFields([
      {
        title: "카테고리명",
        key: "name",
        type: "input",
        required: true,
      },
      {
        title: "노출 순번",
        key: "order",
        type: "number",
        required: true,
      },

    ]);
  }, [mode]);

  const _submit = (form) => {
    if (mode === "detail") {
      const data = form;
      selectedItem.name === form.name && delete data.name;
      systemAlert("카테고리가 등록되어있는 세미나 모집의 카테고리 정보도 함께 변경됩니다.\n 정말 변경하시겠습니까?",
        {
          buttons: [
            {
              color: "text",
              label: "취소"
            },
            {
              label: '수정',
              color: 'red',
              onClick: () => {
                editSeminarCategory(data, form.idx)
                  .then(() => {
                    toast.success("수정되었습니다.");
                    cancel();
                    submit && submit();
                  }).catch(err => {
                    console.error(err);
                  });
              }
            }
          ]
        });


    } else {
      addSeminarCategory(form)
        .then(res => {
          toast.success("등록되었습니다.");
          cancel();
          submit && submit();
        }).catch(err => {
          console.error(err);
        });

    }
  };

  const {
    form,
    setForm,
    errors,
    handleOnChange,
    handleSubmit,
    setOriginForm,
    setValidateFields,
  } = useForm(
    defaultForm,
    _submit,
  );

  useEffect(() => {
    setValidateFields(fields);
    setMode(selectedItem ? 'detail' : 'create');
    if (selectedItem) {
      setForm(selectedItem);
      setOriginForm(selectedItem);
    } else {
      setForm(defaultForm);
      setOriginForm(defaultForm);
    }
  }, [open, selectedItem]);

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="item-write">
        <ModalHeader>
          {selectedItem &&
            <>"{selectedItem.name}"
            </>} 카테고리 {mode === "create" ? "신규 등록" : "수정"}
        </ModalHeader>

        <Form
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          submitText={mode === 'create' ? '등록' : '수정'}
          submit={handleSubmit}
          cancel={cancel}
        />
      </div>

    </Modal>
  );
};

export default Category;